<template>
  <a-modal width="20%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item :label="$t('平台抽成')" prop="platformRate" >
        <a-input-number v-model="form.platformRate" :maxLength="8" :min="0" :step="0.1" :max="50" :placeholder="$t('请输入')+'平台抽成'"/>
        <span>%(百分)</span>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitMerchantForm"  >
            {{$t('确定')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import {  merchantAudit, marginAudit} from '@/api/merchant/merchantApply'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {updateRate} from "@/api/merchant/merchantMerchant";


export default {
  name: 'AuditForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      record: {
        id:null,
      } ,
      errorMessage: null,
      // 表单参数
      form: {
        id: null,
        isPass:true,
        platformRate: 0,
      },
      formType: '',
      open: false,
      rules: {
        platformRate: [
          { required: true, message: '平台抽成'+this.$t('不能为空'), trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.errorMessage = null,
      this.formType = 1
      this.record={
        id:null,
      }
      this.form = {
        id: null,
        platformRate: 0,
        isPass:true
      }

    },
    /** 修改按钮操作 */
    handleAudit(record) {
      this.reset()
      this.form.id= record.id
      this.form.platformRate = record.platformRate
      this.open = true
      this.formTitle="费率修改"
    },
    submitMerchantForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message= '修改成功'
          updateRate(this.form).then(response => {
            if (response.code==='20001') {
              this.$message.success(message, 3);
              this.open = false;
              this.$emit('ok')
            }
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style  lang="less" scoped>
.info-table {
  tr {
    height: 50px;
  }
  td {
    display: table-cell;
    vertical-align: top;
    font-size: 16px;
  }
  .first {
    width: 120px;
  }
  .data {
    width: 280px;
  }
}
</style>
